const CompanySearch = ({
  onChange,
  onClear,
  onFocus,
  placeholder,
  searchTerm,
  className,
}) => {
  const handleInputChange = e => {
    e.preventDefault();
    onChange(e.target.value);
  };

  return (
    <input
      type="text"
      id="Company"
      name="Company"
      data-name="Company"
      className={className}
      required
      placeholder={placeholder}
      onInput={handleInputChange}
      onFocus={onFocus}
      value={searchTerm}
    />
  );
};

CompanySearch.defaultProps = {
  placeholder: '',
  value: '',
};

export default CompanySearch;



// WEBPACK FOOTER //
// ./AutoComplete/containers/CompanySearch/CompanySearch.js